import React from 'react';

const UserRoles = () => {
  return (
    <div className="user-roles">
      <div className="page-header">
        <h2>Kullanıcı Rolleri</h2>
        <p>Kullanıcı yetkilerini yönetin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default UserRoles; 